import { EventObject } from '../graphql/graphql';
import { createSlug, createUrlTitle } from './formatter';

export function formatUrl(event: EventObject): string {
    const city = event?.address?.city?.toLowerCase();

    if (event) {
        const correctCategory = createSlug(event?.category as string);
        const correctEventName = createUrlTitle((event.title ?? 'title').trim());

        // Redirect to the full URL structure with ID
        return `events/${city}/community/${correctCategory}/${correctEventName}/${event.shortEventId}`;
    }

    // Backup Redirect - go to city page
    return `events`;
}
